import React from "react";
import useFetch from "../../../../hooks/useFetch";
import InitialData from "../../../globals/InitialData";
import ResiduesItem from "./residuesItem";

export default function OrderRowProductSuppliers({ order_id }) {
  const { value, error, loading } = useFetch(
    "/api/v1/product_suppliers/balance_by_order?order_id=" + order_id,
    {},
    [order_id]
  );

  const cheapestIds = React.useMemo(() => {
    if (!value) return new Set();
    const groups = {};
    value.forEach((item) => {
      const sku = item.originalCode;
      if (!groups[sku]) groups[sku] = [];
      groups[sku].push(item);
    });
    const ids = new Set();
    Object.values(groups).forEach((items) => {
      const isRivile = (i) => typeof i.supplier?.name === "string" && i.supplier.name.startsWith("vv_");
      const rivileItems = items.filter((i) => isRivile(i) && i.wholesale_price > 0);
      const otherItems = items.filter((i) => !isRivile(i) && i.wholesale_price > 0);
      let cheapestRivile = null;
      if (rivileItems.length > 0) {
        cheapestRivile = rivileItems.reduce((min, i) => parseFloat(i.wholesale_price) < parseFloat(min.wholesale_price) ? i : min);
      }
      const candidates = [...otherItems, ...(cheapestRivile ? [cheapestRivile] : [])];
      if (candidates.length === 0) return;
      const cheapest = candidates.reduce((min, i) => parseFloat(i.wholesale_price) < parseFloat(min.wholesale_price) ? i : min);
      ids.add(cheapest.id);
    });
    return ids;
  }, [value]);

  if (error || loading || value?.length == 0) return <InitialData loading={loading} error={error} />;

  return (
    <div className="table-responsive">
      <table className="table">
        <tbody>
          {value?.map((item) => (
            <ResiduesItem key={item.id} item={item} isCheapest={cheapestIds.has(item.id)} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
